import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { maskPhone } from "../../lib/format";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const COMPANY = [["phone", "Telefone da empresa"], ["email", "E-mail corporativo", 1, "email"], ["zip", "CEP"], ["street", "Endereço", 2], ["number", "Número"], ["complement", "Complemento"],
  ["district", "Bairro"], ["city", "Cidade"], ["state", "Estado (UF)"]];
const PHONES = ["phone", "contact_phone"];
const CONTACT = [["contact_name", "Nome completo *", 2], ["contact_role", "Cargo"], ["contact_email", "E-mail (login) *", 1, "email"], ["contact_phone", "WhatsApp/telefone *"]];

function Fields({ list, f, set }) {
  return (
    <div className="grid sm:grid-cols-2 gap-3">{list.map(([k, l, span, type]) => (
      <div key={k} className={span === 2 ? "sm:col-span-2" : ""}><Label className="text-xs" htmlFor={`profile-${k}`}>{l}</Label>
        <Input id={`profile-${k}`} type={type || "text"} inputMode={PHONES.includes(k) ? "tel" : undefined} placeholder={PHONES.includes(k) ? "(21) 97261-1236" : undefined}
          value={f[k] || ""} onChange={(e) => set({ ...f, [k]: PHONES.includes(k) ? maskPhone(e.target.value) : e.target.value })} className="mt-1" data-testid={`profile-input-${k}`} /></div>))}
    </div>);
}

export function ClientProfileDialog({ cid, open, onOpenChange, onSaved }) {
  const [f, setF] = useState(null);
  const [orig, setOrig] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) api.get(`/backoffice/clients/${cid}/profile`).then((r) => { setF({ ...r.data, phone: maskPhone(r.data.phone), contact_phone: maskPhone(r.data.contact_phone) }); setOrig(r.data.contact_email); }).catch((e) => toast.error(errMsg(e))); }, [open, cid]);
  const emailChanged = f && orig && f.contact_email.trim().toLowerCase() !== orig;
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/backoffice/clients/${cid}/profile`, f);
      toast.success(data.email_changed ? "Dados salvos. O login agora é o novo e-mail — reenvie o acesso." : "Dados do cliente atualizados.");
      onOpenChange(false); onSaved?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="client-profile-dialog">
        <DialogHeader><DialogTitle>Editar dados do cliente</DialogTitle><DialogDescription>Dados da empresa e da pessoa de contato. Todas as alterações ficam registradas na auditoria.</DialogDescription></DialogHeader>
        {!f ? <div className="py-8 text-center text-sm text-slate-500">Carregando...</div> : <div className="space-y-5">
          <section className="space-y-2"><div className="label-xs">Empresa</div><Fields list={COMPANY} f={f} set={setF} /></section>
          <section className="space-y-2"><div className="label-xs">Pessoa de contato (administrador do cliente)</div><Fields list={CONTACT} f={f} set={setF} />
            {emailChanged && <div className="rounded-md border border-amber-300 bg-amber-50 p-2.5 text-xs text-amber-900" data-testid="profile-email-warning">O e-mail de login será alterado de <b>{orig}</b> para <b>{f.contact_email.trim().toLowerCase()}</b>. O link de acesso anterior deixará de funcionar.</div>}</section>
          {!f.can_edit && <div className="text-xs text-rose-700">Você não tem permissão para alterar os dados do cliente.</div>}
          <div className="flex justify-end gap-2"><Button variant="outline" onClick={() => onOpenChange(false)} data-testid="profile-cancel">Cancelar</Button>
            <Button onClick={save} disabled={busy || !f.can_edit} data-testid="profile-save">{busy ? "Salvando..." : "Salvar alterações"}</Button></div>
        </div>}
      </DialogContent>
    </Dialog>);
}
